import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-tft-solo-placements',
  templateUrl: './tft-placements.component.html'
})
export class TftPlacementsComponent {
  service = 'placements';
  availableServices = services['tft'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'tft',
    service: 'placements',
    type: 'solo',
    title: {
      en: 'Placements',
    },
    subtitle: {
      en: "Guaranteed average of 3rd Place in Rank and 2nd in Double Up",
      fr: "Moyenne garantie de 3e place en classement et 2e en Double Up",
      de: "Garantierte Durchschnittsplatzierung auf Platz 3 im Rang und auf Platz 2 im Double Up",
      pt: "Média garantida de 3º lugar em classificação e 2º em Double Up",
      es: "Media garantizada de 3er puesto en clasificación y 2º en Double Up",
    },
    start: DivisionsService.getValueByRank('Gold I', 'tft'),
    desired: 5,
    serviceName: {
      en: 'Matches',
      fr: 'Parties',
      de: 'Spiele',
      pt: 'Jogos',
      es: 'Partidas',
    },
    min: 1,
    max: 5
  }

  serviceFaqs = {
    en: [
      {
        question: "What Does A Placement Boosting Guarantee?",
        answer: "Placements assure an average of 3rd or better in 3 to 5 placements, 4th or better in 2 and no guarantees for 1. Double Up Placements assure an average of 2nd or better in 2 to 5 placements and no guarantees for 1."
      },
      {
        question: "What If I Dont Get An Average of at Least 3rd Place in Rank Placements?",
        answer: "Typically we perform better than an average of 3rd place, but in case we drop below it, you will be compensated with a free division, right after the placements are complete."
      },
      {
        question: "What If I Dont Get An Average of at Least 2nd Place in Double Up Placements?",
        answer: "Usually we do better than an average of 3rd place, but in case we fail to achieve it, you will be compensated with a free division, right after the placements are complete."
      },
      {
        question: "Can I Still Purchase If I have Already Played One Or More Placements?",
        answer: "Indeed, you can. Simply select your previous season rank and the number of remaining placements from the banner above."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Que garantit un Placement Boosting ?",
        answer: "Les placements assurent en moyenne une 3e place ou mieux sur 3 à 5 parties, une 4e ou mieux sur 2, et aucune garantie pour 1. En Double Up, c'est une moyenne de 2e ou mieux sur 2 à 5 parties, mais sans garantie pour 1."
      },
      {
        question: "Et si je n'obtiens pas une moyenne d'au moins 3e place en placements classés ?",
        answer: "On fait généralement mieux qu'une moyenne de 3e place, mais si jamais on descend en dessous, tu recevras une division gratuite juste après les placements."
      },
      {
        question: "Et si je n'obtiens pas une moyenne d'au moins 2e place en Double Up ?",
        answer: "Normalement, on fait mieux qu'une 3e place en moyenne, mais si ce n'est pas le cas, tu seras compensé avec une division gratuite après les placements."
      },
      {
        question: "Puis-je acheter si j'ai déjà joué un ou plusieurs placements ?",
        answer: "Bien sûr ! Sélectionne simplement ton rang de la saison précédente et le nombre de placements restants dans la bannière ci-dessus."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was garantiert ein Placement Boosting?",
        answer: "Placements bringen dir im Schnitt Platz 3 oder besser in 3 bis 5 Spielen, Platz 4 oder besser in 2, aber keine Garantie für 1. Im Double Up bekommst du durchschnittlich Platz 2 oder besser in 2 bis 5 Spielen, aber keine Garantie für 1."
      },
      {
        question: "Was, wenn ich im Rank Placement keinen Schnitt von mindestens Platz 3 erreiche?",
        answer: "Normalerweise performen wir besser als Platz 3 im Schnitt, aber falls wir darunter fallen, bekommst du direkt nach den Placements eine kostenlose Division."
      },
      {
        question: "Was, wenn ich im Double Up Placement keinen Schnitt von mindestens Platz 2 erreiche?",
        answer: "Meistens erreichen wir einen besseren Schnitt als Platz 3, aber falls nicht, kriegst du eine kostenlose Division als Entschädigung nach den Placements."
      },
      {
        question: "Kann ich trotzdem kaufen, wenn ich schon ein oder mehrere Placements gespielt habe?",
        answer: "Klar! Wähl einfach deinen vorherigen Saisonrang und die Anzahl deiner verbleibenden Placements im Banner oben aus."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O que garante um Placement Boosting?",
        answer: "Os placements garantem, em média, 3º lugar ou melhor em 3 a 5 jogos, 4º ou melhor em 2, e sem garantias para 1. No Double Up, garantimos 2º lugar ou melhor em 2 a 5 jogos, mas sem garantia para 1."
      },
      {
        question: "E se eu não conseguir uma média de pelo menos 3º lugar nos placements?",
        answer: "Normalmente, fazemos melhor que uma média de 3º lugar, mas se ficarmos abaixo disso, recebes uma divisão grátis logo após os placements."
      },
      {
        question: "E se eu não conseguir uma média de pelo menos 2º lugar no Double Up?",
        answer: "Geralmente conseguimos um desempenho melhor que 3º lugar, mas se não atingirmos, compensamos com uma divisão grátis logo após os placements."
      },
      {
        question: "Posso comprar mesmo que já tenha jogado um ou mais placements?",
        answer: "Claro! Basta selecionar o teu rank da temporada passada e o número de placements restantes na faixa acima."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué garantiza un Placement Boosting?",
        answer: "Los placements suelen asegurar un promedio de 3º o mejor en 3 a 5 partidas, 4º o mejor en 2 y sin garantías para 1. En Double Up, aseguramos un promedio de 2º o mejor en 2 a 5 partidas, pero sin garantía para 1."
      },
      {
        question: "¿Qué pasa si no consigo un promedio de al menos 3º puesto en los placements?",
        answer: "Normalmente lo hacemos mejor que un 3º puesto de media, pero si bajamos de ahí, te compensaremos con una división gratis justo después de los placements."
      },
      {
        question: "¿Qué pasa si no consigo un promedio de al menos 2º puesto en Double Up?",
        answer: "Por lo general, conseguimos un promedio mejor que 3º, pero si no lo logramos, recibirás una división gratis justo después de los placements."
      },
      {
        question: "¿Puedo comprar si ya he jugado uno o más placements?",
        answer: "¡Por supuesto! Solo selecciona tu rango de la temporada anterior y el número de placements restantes en el banner de arriba."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "TFT Boost - Placements Boosting for Teamfight Tactics",
      fr: "Boost TFT - Boosting de Placements pour Teamfight Tactics",
      de: "TFT Boost - Placements Boosting für Teamfight Tactics",
      pt: "TFT Boost - Boost de placements para Teamfight Tactics",
      es: "TFT Boost - Boost de clasificación para Teamfight Tactics",
    },
    metaDescription: {
      en: "Our Master+ boosters ensure that you have an average of at least 3rd place in the most critical Teamfight Tactics matches of the season",
      fr: "Nos boosters Master+ vous garantissent une moyenne d\'au moins la 3e place dans les matchs de Teamfight Tactics les plus critiques de la saison",
      de: "Mit unseren Master+ Boostern ist sichergestellt, dass du in den kritischsten Teamfight Tactics Matches der Saison im Durchschnitt mindestens den 3. Platz belegst.",
      pt: "Os nossos boosters Master+ garantem que tu tenhas uma média de pelo menos o 3º lugar nas partidas mais críticas de Teamfight Tactics da temporada.",
      es: "Nuestros boosters Master+ te garantizan una media de al menos 3er puesto en las partidas de Teamfight Tactics más importantes de la temporada.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}